import { ReactNode } from 'react';
// import { useFullScreen } from '../../hooks/useFullScreen';

interface FullScreenHandlerProps {
  children: ReactNode;
}

export const FullScreenHandler: React.FC<FullScreenHandlerProps> = ({
  children,
}) => {
  // useFullScreen();
  return <>{children}</>;
};
